import React from 'react';
import styled from '@emotion/styled';
import {
	IRadioButtonProps,
	ITheme,
	RadioButton,
	StyledRadioButtonIcon,
	VisuallyHidden,
} from '../../../../../../ui';
import { useTranslationForType } from '../../hooks/useTranslationForType';
import { CreditCardLogo } from '../../logo';
import { useCreditCardFormContext } from '../helpers/useCreditCardFormContext';
import { useDetectTypeByCreditCardNumber } from '../helpers/useDetectTypeByCreditCardNumber';
import { CreditCardType } from '../../../../domain/models';
import { capitalize } from '../../../../../shared/utils/capitalize';

export type CreditCardTypeOptionProps = Partial<IRadioButtonProps> & {
	type: CreditCardType;
};

export const CreditCardTypeOption = ({
	type,
	...rest
}: CreditCardTypeOptionProps) => {
	const { register } = useCreditCardFormContext();
	const ariaLabel = useTranslationForType(type);

	useDetectTypeByCreditCardNumber();

	return (
		<StyledCreditCardTypeOption
			value={type}
			ariaLabel={ariaLabel}
			label={
				<>
					<CreditCardLogo type={type} />
					<VisuallyHidden as="span">{capitalize(type)}</VisuallyHidden>
				</>
			}
			{...rest}
			{...register('creditCardType')}
		/>
	);
};

export const StyledCreditCardTypeOption = styled(RadioButton)<{}, ITheme>`
	display: inline-flex;
	align-items: center;

	& + & {
		margin-left: 40px;
	}

	${StyledRadioButtonIcon} {
		margin-right: 24px;
	}
`;
